module.exports = __webpack_public_path__ + "img/backhome@2x.bf95f89f.png";